import React from 'react';
import type { SmartADVItem } from '@shared/models';
import { CategoryID } from '@sbt-web/network/types';
import { shouldShowBigCards } from '@client/components/Search/Containers/AdItem';
import styles from './index.module.scss';
import { LiraAdvContainer } from '@sbt-web/adv';

function addSmartADVItem(
  item: SmartADVItem,
  listingCategory: CategoryID,
  isMobile: boolean
) {
  const config = isMobile ? item.msite : item.desktop;

  if (config === null) {
    return;
  }

  if (config.source === 'lira') {
    return (
      <div
        className={styles['smart-adv-lira']}
        style={config.style}
        data-cell-size={shouldShowBigCards(listingCategory) ? 'big' : 'normal'}
      >
        <SmartLiraAdvContainer id={config.id} />
      </div>
    );
  }
}

const SmartLiraAdvContainer = ({ id }: { id: string }) => {
  return (
    <div className={styles['smart-adv-lira-wrapper']} style={{ width: '100%' }}>
      <LiraAdvContainer
        idForAd={id}
        withPlaceholder={true}
        className={styles['smart-adv-lira']}
      />
    </div>
  );
};

export { addSmartADVItem, SmartLiraAdvContainer };
